import { OWebPageBase } from "oweb";
import PUserSignupComponent from "@/components/pages/oweb/PUserSignup.vue";
import { VueConstructor } from 'vue';

export default class PUserSignup extends OWebPageBase<VueConstructor> {
	getName() {
		return "PUserSignup"
	}

	getRoutes() {
		return [
			{
				title: "OO_LANG_SIGNUP",
				path: "/signup"
			},
			{
				title: "OO_LANG_SIGNUP",
				path: "/signup/:step",
				pathOptions: {
					step: /one|two|three/
				}
			} ]
	}

	getComponent() {
		return PUserSignupComponent;
	}
}